
// check if localhost is running

export const isLocalhost = window.location.hostname === "localhost";

export const isProduction = !isLocalhost;
export const PRODUCTION_URL = "https://api.detstudy.com/";
export const DEVELOPMENT_URL = "http://localhost:8000/";
export const BASE_URL = isProduction ? PRODUCTION_URL : DEVELOPMENT_URL;

export const DAILY_PRACTICE_LIMIT = 10;
export const CURRENCY = "$";
export const APP_NAME = "Det Study";
export const GOOGLE_API_KEY = "347553604450-p5gjb68l8sataq0m6o3memmhun0u49st.apps.googleusercontent.com";







